// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div ng-bind=\"grid.appScope.getSavings(row.entity) | invCurrency:row.entity.currency\"></div>\n</div>\n";
// Exports
module.exports = code;